import React, { useEffect, useRef } from "react";
import HeatmapLegend from "./HeatmapLegend";
import { TacticScale, TacticStat, Tactics, TacticsData } from "../types/data";
import Popover from "./Popover";
import { useState } from "react";
import TeamTable from "./TeamTable";
import CardWrapper from "./CardWrapper";
import PopoverCard from "./PopoverCard";
import Dropdown from "./Dropdown";
import {
  game_counterfactuals
} from "../router/resources/data";
import { PopupData } from "../types/data";
import { createDisplayData } from "../router/resources/utils";
import InputProbability from "./InputProbability";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";

interface Props {
  tacticsData: TacticsData;
  defaultData: TacticsData;
  homeTeam: number;
  awayTeam: number;
  handleTacticsData: React.Dispatch<React.SetStateAction<TacticsData>>;
  changeHomeTeam: (val: number) => void;
  changeAwayTeam: (val: number) => void;
  scales: TacticScale;
  homeWin: number;
  awayWin: number;
}

const AnalysisDashboard: React.FC<Props> = ({
  tacticsData,
  defaultData,
  handleTacticsData,
  homeTeam,
  changeHomeTeam,
  changeAwayTeam,
  homeWin,
  awayWin,
  awayTeam,
  scales,
}) => {
  const [homeProbability, setHomeProbability] = useState<string>(homeWin.toString());
  const [awayProbability, setAwayProbability] = useState<string>(awayWin.toString());
  const [targetTeam, setTargetTeam] = useState(0);

  const [counterfactuals, setCounterfactuals] = useState<TacticsData[]>([]);
  const [page, setPage] = useState(0);

  const [displayData, setDisplayData] = useState<TacticsData>(tacticsData);

  const [open, setOpen] = useState(false);
  const [metric, setMetric] = useState<Tactics>();
  const [value, setValue] = useState<number>(0);
  const [isHome, setIsHome] = useState<boolean | undefined>();
  const [isEfficiency, setIsEfficiency] = useState<boolean>(false);
  const [popupData, setPopUpData] = useState<PopupData>();

  const getGameCounterfactuals = async () => {
    const requestData = {
      ...displayData,
      target_team: targetTeam === 0 ? "home" : "away",
      target_prob: targetTeam === 0 ? (Number(homeProbability) * 0.01) : (Number(awayProbability) * 0.01),
    };
    const returnData = await game_counterfactuals(requestData);
    setCounterfactuals(returnData.cfs_list);
    setDisplayData(createDisplayData(returnData.cfs_list[0]));
    setPage(0);
    return;
  };

  console.log(counterfactuals.length);

  const handleLocking = (
    isHome: boolean,
    isUsage: boolean,
    metric: Tactics
  ) => {
    setDisplayData((prevData) => {
      const newData = { ...prevData };
      if (isUsage) {
        if (isHome) {
          newData.home[metric].lock![1] = !prevData.home[metric].lock![1];
        } else {
          newData.away[metric].lock![1] = !prevData.away[metric].lock![1];
        }
      } else {
        if (isHome) {
          newData.home[metric].lock![0] = !prevData.home[metric].lock![0];
        } else {
          newData.away[metric].lock![0] = !prevData.away[metric].lock![0];
        }
      }
      return newData;
    });
  };

  const changePreviousPage = () => {
    if (page <= 0) return;
    const prevPage = page - 1;
    setPage(prevPage);
    setDisplayData(createDisplayData(counterfactuals[prevPage]));
  };

  const changeNextPage = () => {
    if (page + 1 >= counterfactuals.length) return;
    const nextPage = page + 1;
    setPage(nextPage);
    setDisplayData(createDisplayData(counterfactuals[nextPage]));
  };



  return (
    <div>
      {open && (
        <PopoverCard closeModal={() => setOpen(false)}>
          <Popover
            metric={metric!}
            value={value}
            isEfficiency={isEfficiency}
            isHome={isHome!}
            handleValue={setValue}
            handleData={setDisplayData}
            data={tacticsData}
            defaultData={defaultData}
            popupData={popupData!}
            setOpen={setOpen}
          />
        </PopoverCard>
      )}
      <div className="w-full flex flex-col items-center my-2">
        {/*
        <h1 className="text-4xl font-bold text-center my-5">
          Welcome to B11 Basketball Analysis
        </h1>
        */}
        <div className="w-full flex flex-row items-center mx-20 justify-center">
          <Dropdown
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            setHomeTeam={changeHomeTeam}
            setAwayTeam={changeAwayTeam}
            disabled={true}
          ></Dropdown>
        </div>
        <div className="w-full flex flex-row items-center my-2 justify-center text-sm">
          <CardWrapper>
            <div className="text-center">High</div>
            <HeatmapLegend upperBound={100}></HeatmapLegend>
            <div className="text-center">Low</div>
          </CardWrapper>
          <CardWrapper>
            <TeamTable
              changeSetOpen={setOpen}
              tableData={displayData}
              defaultData={defaultData}
              handleMetric={setMetric}
              handleValue={setValue}
              handleIsHome={setIsHome}
              handlePopupData={setPopUpData}
              handleIsEfficiency={setIsEfficiency}
              scales={scales}
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              handleLocks={handleLocking}
              mode={1}
            />
            {counterfactuals.length != 0 && (
            <div className="mt-4 text-sm">
              <div className="flex justify-between pagination">
                <button
                  disabled={page + 1 <= 1 && counterfactuals.length != 0}
                  className={page + 1 <= 1 && counterfactuals.length != 0 ? "hover:cursor-pointer flex items-center text-gray-400" : "hover:cursor-pointer flex items-center"}
                  onClick={changePreviousPage}
                >
                  <FaChevronLeft className="mr-1" />
                  Previous Strategy
                </button>
                <div>
                  {page + 1} / {counterfactuals.length}
                </div>
                <button
                  disabled={(page + 1 >= counterfactuals.length) && counterfactuals.length != 0}

                  className={((page + 1 >= counterfactuals.length) && counterfactuals.length != 0) ? "hover:cursor-pointer flex items-center text-gray-400" : "hover:cursor-pointer flex items-center"}
                  onClick={changeNextPage}
                >
                  Next Strategy
                  <FaChevronRight className="ml-1" />
                </button>
              </div>
            </div>
            )}
          </CardWrapper>
          <div className="flex flex-col items-center my-2 w-1/3">
            <CardWrapper>
              <button
                className="bg-neutral-400 hover:bg-neutral-300 text-black font-bold py-2 px-4 rounded w-80"
                onClick={async () => {
                  getGameCounterfactuals();
                }}
              >
                Generate Strategies
              </button>
            </CardWrapper>
            <CardWrapper>
              <InputProbability
                currentHomeProbability={homeWin.toString()}
                currentAwayProbability={awayWin.toString()}
                changeHomeProbability={setHomeProbability}
                changeAwayProbability={setAwayProbability}
                changeTargetTeam={setTargetTeam}
              />
            </CardWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisDashboard;
